
import FilterAdd from "../../../assets/filled/FilterAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FilterAddIcon({ className, dataTestid = "FilterAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FilterAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
